import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Webinars from "@/pages/Webinars";

export const Route = createFileRoute("/es/webinars/")({
  head: () => buildRouteHead("/es/webinars"),
  component: Webinars,
});

